import React from 'react'

type ClientCellProps = {
  name?: string | null
  reference?: string | null
}

const ClientCell = ({ name, reference }: ClientCellProps) => (
  <div className='wallet-admin__client'>
    <span>{name?.trim() || '—'}</span>
    {reference?.trim() ? <small>{reference.trim()}</small> : null}
  </div>
)

export { ClientCell }
